<template>
  <v-dialog
    v-model="dialogStatus"
    content-class="dialog-fullscreen hide-scrollbar"
    fullscreen
    hide-overlay
    transition="dialog-top-transition"
    persistent
  >
    <v-toolbar dark color="primary">
      <v-btn icon dark @click="close">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-toolbar-title>{{ $t("module.create") }}</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-card>
      <v-container v-if="typeSelected">
        <v-row>
          <v-col cols="12" sm="0" md="6">
            <ModulePreview
              v-if="
                (sm != undefined || md != undefined) && type != ModuleTypes.MAP
              "
              :type.sync="type"
              :sizeSm.sync="sm"
              :sizeMd.sync="md"
              :title="title"
              :content="content"
              :deveui="deveui"
              :meta="styleMetas"
              :tagKey="tagKey"
            />
            <style-picker-module
              :type="type"
              :metas="metas"
              v-on:update="updateStyleMeta"
              v-if="
                isInType(type, [
                  ModuleTypes.CHART,
                  ModuleTypes.MULTICHART,
                  ModuleTypes.TRENDCHART,
                  ModuleTypes.GAUGE,
                  ModuleTypes.TILTCHART,
                ])
              "
            />
          </v-col>

          <v-col cols="12" sm="12" :md="hasStyle ? 6 : 12">
            <v-card flat>
              <v-card-title>
                <span class="headline">{{ $t("module.create") }}</span>
              </v-card-title>

              <v-form ref="moduleForm" v-model="valid" :lazy-validation="false">
                <v-card-text>
                  <v-icon style="margin-right: 0.3rem"
                    >mdi-format-list-bulleted-type</v-icon
                  ><span style="font-size: 1rem; font-weight: bold">
                    {{ getTypeName(type) }}
                  </span>
                  <v-icon large color="primary" @click="typeSelected = false"
                    >mdi-pen</v-icon
                  >
                </v-card-text>

                <v-card-text>
                  <v-text-field
                    :label="$t('module.fields.title')"
                    name="name"
                    prepend-icon="domain"
                    type="text"
                    v-model="title"
                    :rules="reqRule"
                  ></v-text-field>
                </v-card-text>

                <v-textarea
                  v-if="isType(MType.INFOCARD, type)"
                  :label="$t('module.fields.content')"
                  prepend-icon="mdi-note-text-outline"
                  type="text"
                  v-model="content"
                  :rules="reqRule"
                  class="ma-0 pa-4"
                  outlined
                ></v-textarea>

                <TextEditorModule
                  v-if="isType(MType.TEXT, type)"
                  v-on:update-html="updateContent"
                  :content="content"
                ></TextEditorModule>

                <div
                  v-if="
                    isType(
                      [
                        MType.CHART,
                        MType.GAUGE,
                        MType.IMAGE,
                        MType.WEATHER,
                        MType.SINGLE,
                        MType.RAWTABLE,
                        MType.IMAGEMAP,
                        MType.INFOCARD,
                        MType.TRENDCHART,
                        MType.TILTCHART,
                      ],
                      type
                    )
                  "
                >
                  <v-card-text>
                    <v-autocomplete
                      autocomplete="off"
                      :loading="tagStatus.loading"
                      :label="$t('alarm.fields.tag')"
                      v-model="deveui"
                      :items="tags"
                      item-text="name"
                      item-value="deveui"
                      prepend-icon="mdi-cellphone-link"
                      clearable
                    ></v-autocomplete>
                  </v-card-text>
                </div>

                <div
                  v-if="
                    isType(
                      [
                        MType.CHART,
                        MType.GAUGE,
                        MType.SINGLE,
                        MType.TRENDCHART,
                      ],
                      type
                    )
                  "
                >
                  <v-card-text>
                    <v-autocomplete
                      autocomplete="off"
                      :disabled="tagStatus.loading || disabledKeys"
                      :loading="tagDataStatus.loading"
                      :label="$t('alarm.fields.tagDataKey')"
                      v-model="tagKey"
                      :items="keys"
                      :rules="autocompleteRules"
                      required
                      item-text="key"
                      item-value="key"
                      prepend-icon="mdi-key"
                    ></v-autocomplete>
                  </v-card-text>
                </div>

                <div v-if="isType(MType.GAUGE, type)">
                  <v-row
                    style="max-width: 100% !important"
                    class="ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-col cols="12" sm="6" md="6">
                      <v-text-field
                        :label="$t('module.fields.min')"
                        type="number"
                        v-model="min"
                        single-line
                        prepend-icon="mdi-priority-low"
                        :rules="reqRule"
                      />
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-text-field
                        :label="$t('module.fields.max')"
                        type="number"
                        v-model="max"
                        single-line
                        prepend-icon="mdi-priority-high"
                        :rules="reqRule"
                      />
                    </v-col>
                  </v-row>
                </div>

                <!-- <div class="pl-4" v-if="isType(MType.MULTICHART, type)">
          <v-checkbox
            class="font-weight-light preserve-spacing"
            :label="$t('module.fields.sync_chart')"
            v-model="syncChart"
          />
        </div> -->

                <v-card-text v-if="isType(MType.IFRAME, type)">
                  <v-text-field
                    :label="$t('module.fields.url')"
                    prepend-icon="url"
                    type="text"
                    v-model="url"
                    :rules="reqRule"
                  ></v-text-field>
                </v-card-text>

                <div
                  v-if="
                    isType([MType.IMAGE, MType.IMAGEMAP], type) &&
                    isEmpty(deveui)
                  "
                >
                  <v-card-text class="text-center">
                    <span>{{ $t("common.or").toUpperCase() }}</span>

                    <v-file-input
                      :label="$t('module.fields.image')"
                      v-model="image"
                    />
                  </v-card-text>
                </div>

                <!--Check if the condition is met to show this-->
                <div v-if="typeHasMeta()">
                  <v-card-text class="text-center">
                    <span class="title font-weight-light">{{
                      $t("module.metas").toUpperCase()
                    }}</span>
                    <v-divider />
                    <v-select
                      :items="metaKeysFiltered"
                      :label="$t('module.meta.label')"
                      item-text="name"
                      item-value="key"
                      v-model="meta.key"
                      prepend-icon="mdi-plus"
                      @change="metaChanged"
                      auto-select-first
                    ></v-select>

                    <v-text-field
                      :label="metaFieldLabel(1)"
                      prepend-icon="mdi-alpha-v"
                      type="text"
                      v-model="meta.valueMatch"
                      v-if="metaValueMatchField"
                    ></v-text-field>

                    <v-text-field
                      :label="metaFieldLabel(0)"
                      prepend-icon="mdi-alpha-n"
                      type="text"
                      v-model="meta.value"
                      v-if="metaValueField"
                    ></v-text-field>

                    <v-select
                      :items="metaIcons"
                      :label="$t('module.meta.icon')"
                      v-model="meta.value"
                      prepend-icon="mdi-auto-fix"
                      v-if="metaIconField"
                    >
                      <template slot="item" slot-scope="data">
                        <v-icon small>{{ data.item }}</v-icon>
                      </template>
                      <template slot="selection" slot-scope="data">
                        <v-icon medium>{{ data.item }}</v-icon>
                      </template>
                    </v-select>

                    <v-autocomplete
                      autocomplete="off"
                      :loading="tagStatus.loading"
                      :label="$t('alarm.fields.tag')"
                      v-model="meta.value"
                      :items="tags"
                      required
                      item-text="name"
                      item-value="deveui"
                      prepend-icon="mdi-cellphone-link"
                      clearable
                      v-if="metaTagField"
                      @change="deveuiChanged"
                    ></v-autocomplete>

                    <v-autocomplete
                      :disabled="tagStatus.loading || disabledKeys"
                      :loading="tagDataStatus.loading"
                      :label="$t('alarm.fields.tagDataKey')"
                      v-model="meta.valueMatch"
                      :items="keys"
                      required
                      item-text="key"
                      item-value="key"
                      prepend-icon="mdi-key"
                      autocomplete="off"
                      clearable
                      v-if="
                        (meta.key == 'so_deveui_key' ||
                          meta.key == 'so_tagkey' ||
                          meta.key == 'so_tagkey_x' ||
                          meta.key == 'so_tagkey_y' ||
                          meta.key == 'so_tagkey_x_max' ||
                          meta.key == 'so_tagkey_y_max') &&
                        isType(
                          [MType.MULTICHART, MType.INFOCARD, MType.TILTCHART],
                          type
                        )
                      "
                    ></v-autocomplete>

                    <v-autocomplete
                      :label="$t('module.meta.fields.alarm_id')"
                      v-model="meta.valueMatch"
                      :items="alarms"
                      required
                      item-text="name"
                      item-value="alarmId"
                      prepend-icon="mdi-alarm"
                      autocomplete="off"
                      clearable
                      v-if="meta.key == 'so_alarm_id'"
                    ></v-autocomplete>

                    <v-autocomplete
                      autocomplete="off"
                      :loading="scriptStatus.loading"
                      :label="$t('script.name')"
                      v-model="meta.value"
                      :items="calledScripts"
                      item-text="name"
                      item-value="scriptId"
                      prepend-icon="mdi-cellphone-link"
                      clearable
                      v-if="meta.key == 'so_script_id'"
                    ></v-autocomplete>

                    <!-- Dashboard ID Meta -->
                    <v-autocomplete
                      autocomplete="off"
                      :label="$t('dashboard.name')"
                      v-model="meta.value"
                      :items="dashboards"
                      item-text="name"
                      item-value="dashboardId"
                      prepend-icon="mdi-view-dashboard-variant"
                      clearable
                      v-if="meta.key == 'so_dashboard_id'"
                    ></v-autocomplete>

                    <v-switch
                      v-model="meta.value"
                      v-if="meta.key == 'so_force_colors'"
                      :label="$t('module.meta.desc.forceColors')"
                    ></v-switch>

                    <v-switch
                      v-model="meta.value"
                      v-if="meta.key == 'so_sync_y'"
                      :label="$t('module.meta.fields.sync_y')"
                    ></v-switch>

                    <v-switch
                      v-model="meta.value"
                      v-if="meta.key == 'so_zoom_slider'"
                      :label="$t('module.meta.fields.zoom_slider')"
                    ></v-switch>

                    <v-switch
                      v-model="meta.value"
                      v-if="meta.key == 'so_digital'"
                      :label="$t('module.meta.fields.digital')"
                      :value="true"
                    ></v-switch>

                    <v-btn
                      color="accent"
                      text
                      @click="storeMeta()"
                      :disabled="!canAddMeta(meta.key)"
                    >
                      {{ $t("module.meta.save") }}
                    </v-btn>

                    <!-- 4. Show all the attributes added -->
                    <v-simple-table v-if="this.metas.length > 0">
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left">
                              {{ $t("module.meta.key") }}
                            </th>
                            <th class="text-left">
                              {{ $t("module.meta.valueMatch") }}
                            </th>
                            <th class="text-left">
                              {{ $t("module.meta.value") }}
                            </th>
                            <th class="text-left"></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(m, i) in metas" :key="i">
                            <td class="text-left">
                              {{ metaLangForKey(m.key) }}
                            </td>
                            <td class="text-left">{{ m.valueMatch }}</td>
                            <td class="text-left">
                              {{
                                shouldHaveFriendlyName(m.key)
                                  ? getFriendlyName(m.key, m.value)
                                  : m.value
                              }}
                            </td>
                            <td>
                              <v-btn
                                color="error"
                                fab
                                x-small
                                @click="removeMeta(m)"
                              >
                                <v-icon>mdi-delete</v-icon>
                              </v-btn>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-card-text>
                </div>
              </v-form>

              <v-card-actions>
                <v-spacer></v-spacer>
              </v-card-actions>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close()">{{
                  $t("common.close")
                }}</v-btn>
                <v-btn color="blue darken-1" text @click="submit()">{{
                  $t("common.save")
                }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
      <v-col sm="12" md="12" align="center" v-else>
        <ModuleTypeSelector v-on:update="selectType" />
      </v-col>
    </v-card>
  </v-dialog>
</template>

<script>
import Enum from "@/_helpers/Enum";
import CsharpEnum from "@/_helpers/CsharpEnum";
import { mapState, mapActions } from "vuex";
import Meta from "@/_helpers/ModuleMeta";
import ModuleTypeSelector from "@/components/tag/ModuleTypeSelector";
import ModulePreview from "@/components/common/ModulePreview";
import StylePickerModule from "@/components/common/StylePickerModule";
import ModuleTypes from "@/_helpers/ModuleTypeHelper.js";
import TextEditorModule from "@/components/common/TextEditorModule";

export default {
  name: "ModuleCreate",

  props: ["dialog"],

  mixins: [ModuleTypes],

  data() {
    return {
      valid: false,
      typeSelected: false,

      meta: {
        key: null,
        valueMatch: null,
        value: null,
        deveui: null,
      },

      title: "",
      content: "",
      min: null,
      max: null,
      type: null,
      sm: Enum.ModuleSize.LG,
      md: Enum.ModuleSize.LG,
      deveui: "",
      tagKey: "",
      image: null,
      url: null,
      syncChart: false,
      disabledKeys: false,
      metas: [],
      styleMetas: [],
      metaValueMatchField: false,
      metaValueField: false,
      metaIconField: false,
      metaTagField: false,
      metaBoolField: false,
      indexedTags: [],

      metaDeveui: null,
      moduleTypes: ModuleTypes.types,

      autocompleteRules: [
        (v) => !!v || v === 0 || this.$t("alarm.validation.nameRequired"),
      ],

      reqRule: [
        (v) => !!v || v === 0 || this.$t("alarm.validation.nameRequired"),
      ],
    };
  },

  methods: {
    updateContent(newContent) {
      this.content = newContent;
    },

    close() {
      this.$emit("close-dialog");
      this.metaValueMatchField = false;
      this.metaIconField = false;
      this.metaTagField = false;
      this.metaValueField = false;
      this.typeSelected = false;
      if (this.$refs.moduleForm) this.$refs.moduleForm.reset();
    },

    async submit() {
      if (!this.$refs.moduleForm.validate()) {
        this.valid = false;
        return;
      }

      let allMeta = this.metas;
      if (this.styleMetas.length > 0) allMeta = allMeta.concat(this.styleMetas);

      const data = {
        title: this.title,
        content: this.content,
        min: this.min,
        max: this.max,
        type: this.type,
        sm: this.sm,
        md: this.md,
        deveui: this.deveui,
        key: this.tagKey,
        meta: allMeta,
        w: 3,
        h: 7,
      };

      if (this.type === CsharpEnum.ModuleType.IFRAME) {
        data.content = this.url;
      }

      if (this.type === CsharpEnum.ModuleType.MULTICHART) {
        if (this.syncChart) data.content = 1;
        else data.content = 0;
      }

      await this.create({
        dashboardId: this.currentDashboard.dashboardId,
        payload: data,
      });

      if (
        this.image !== null &&
        this.currentModule.dashboardModuleId !== undefined &&
        (this.currentModule.type === CsharpEnum.ModuleType.IMAGE ||
          this.currentModule.type === CsharpEnum.ModuleType.IMAGEMAP)
      ) {
        let formData = new FormData();
        formData.append("image", this.image);

        await this.postImage({
          moduleId: this.currentModule.dashboardModuleId,
          image: formData,
        });

        this.image = null;
      }

      this.metas = [];
      this.close();
    },

    ...mapActions("tag", ["getTags", "getKeysForTag"]),
    ...mapActions("tagData", { getTdKeys: "getTagDataKeys" }),
    ...mapActions("modules", ["create", "postImage"]),
    ...mapActions("scripts", ["getScripts", "setCurrentScript"]),
    ...mapActions("dashboards", ["getDashboards"]),
    ...mapActions("alarms", ["getAlarms"]),

    sizes(small) {
      if (this.type === null || this.type === undefined) {
        return [];
      }

      if (small) {
        return Enum.SizeForType[this.type].sm;
      }

      return Enum.SizeForType[this.type].md;
    },

    isType(target, type) {
      if (!Array.isArray(target)) {
        return target === type;
      }

      return target.includes(type);
    },

    isEmpty(el) {
      return el === undefined || el === null || el === "";
    },

    metaChanged() {
      let m = Meta.InputFields[this.meta.key];
      this.metaValueMatchField = m.fields[1];
      this.metaValueField = m.fields[0];
      this.metaIconField = m.fields[2];
      this.metaTagField = m.fields[3];
      this.metaBoolField = m.fields[4];

      if (this.meta.key == "so_script_id") {
        this.getScripts();
      } else if (this.meta.key == "so_dashboard_id") {
        this.getDashboards();
      } else if (this.meta.key == "so_alarm_id") {
        this.getAlarms();
      }

      if (m.fields[4]) {
        this.meta.value = true;
      } else this.meta.value = null;
    },

    deveuiChanged() {
      this.getKeysForTag({ tagId: this.meta.value });
    },

    typeHasMeta() {
      if (
        this.type == null ||
        this.type == undefined ||
        Meta.Widgets[this.type] == undefined ||
        Meta.Widgets[this.type].length <= 0
      )
        return false;

      return true;
    },

    metaFieldLabel(index) {
      return Meta.InputFields[this.meta.key].fieldsLabels[index];
    },

    storeMeta() {
      if (this.metaBoolField && !this.meta.value) return;

      this.metas.push({
        key: this.meta.key,
        valueMatch: this.meta.valueMatch,
        value: this.meta.value,
        content: this.meta.content,
      });

      this.meta.valueMatch = null;
      this.meta.value = null;
      this.meta.deveui = null;
    },

    removeMeta(m) {
      this.metas.splice(this.metas.indexOf(m), 1);
    },

    updateStyleMeta(styleMetas) {
      // Set stylemeta reactivily
      this.styleMetas = styleMetas.slice(0, styleMetas.length);
    },

    metaLangForKey(key) {
      for (let i = 0; i < Meta.Keys.length; i++) {
        if (Meta.Keys[i].key === key) return Meta.Keys[i].name;
      }
    },

    indexTags() {
      for (let tag in this.tags) {
        this.indexedTags[this.tags[tag].deveui] = this.tags[tag].name;
      }
    },

    shouldHaveFriendlyName(key) {
      let friendlyNames = [Meta.Enum.DEVEUI];

      return friendlyNames.includes(key);
    },

    getFriendlyName(meta, value) {
      if (Meta.Enum.DEVEUI == meta) {
        return this.indexedTags[value] != undefined
          ? this.indexedTags[value]
          : value;
      }
    },

    selectType(type) {
      this.metas = [];
      this.styleMetas = [];
      this.type = type;
      this.typeSelected = true;

      // Get default size for the type
      let sizes = this.getDefaultSizeForWidget(type);
      this.sm = sizes.sm;
      this.md = sizes.md;
    },

    getTypeName(type) {
      for (let i in this.moduleTypes) {
        if (this.moduleTypes[i].value == type) return this.moduleTypes[i].name;
      }

      return "";
    },

    // This function is used so the user cannot add duplicates of keys that are not allowed
    // Expand this to take in to account all meta keys
    canAddMeta(key) {
      // Allow one
      if (
        key == "so_force_colors" ||
        key == "so_tagkey_x" ||
        key == "so_tagkey_y" ||
        key == "so_tagkey_x_max" ||
        key == "so_tagkey_y_max" ||
        key == "so_decimal_rounding" ||
        key == "so_script_id" ||
        key == "so_dashboard_id" ||
        key == "so_sync_y" ||
        key == "so_zoom_slider" ||
        key == "so_digital" ||
        key == "so_alarm_id"
      ) {
        return this.metas.filter((m) => m.key == key).length <= 0;
      }

      return true;
    },
  },

  computed: {
    ...mapState("tag", { tagStatus: "status", tags: "tags" }),
    ...mapState("tagData", { tagDataStatus: "status", keys: "keys" }),
    ...mapState("dashboards", ["dashboards", "currentDashboard"]),
    ...mapState("modules", { currentModule: "currentModule" }),
    ...mapState("scripts", { scriptStatus: "status", scripts: "scripts" }),
    ...mapState("alarms", ["alarms"]),

    typeValid() {
      return this.type !== null && this.type !== undefined;
    },

    MType() {
      return CsharpEnum.ModuleType;
    },

    dialogStatus() {
      return this.dialog;
    },

    metaKeys() {
      return Meta.Keys;
    },

    metaIcons() {
      return Meta.Icons;
    },

    hasStyle() {
      return this.isInType(this.type, [
        this.ModuleTypes.CHART,
        this.ModuleTypes.MULTICHART,
        this.ModuleTypes.TRENDCHART,
        this.ModuleTypes.GAUGE,
        this.ModuleTypes.TILTCHART,
      ]);
    },

    metaKeysFiltered() {
      return Meta.Keys.filter((m) => Meta.Widgets[this.type].includes(m.key));
    },

    calledScripts() {
      return this.scripts.filter((s) => {
        return s.type == 1;
      });
    },

    keyDisabled() {
      let disabled = [
        CsharpEnum.ModuleType.CHART,
        CsharpEnum.ModuleType.GAUGE,
        CsharpEnum.ModuleType.SINGLE,
        CsharpEnum.ModuleType.INFOCARD,
      ];
      if (
        this.isType(disabled, this.type) &&
        (this.deveui === "" ||
          this.deveui === undefined ||
          (this.deveui == null &&
            (this.meta.valueMatch == null || this.meta.valueMatch === "")))
      ) {
        return true;
      }

      return false;
    },
  },

  created() {
    this.getTags();
    this.indexTags();
    this.disabledKeys = this.keyDisabled;
  },

  watch: {
    // eslint-disable-next-line
    deveui(val, oldVal) {
      if (val != oldVal) {
        this.getKeysForTag({ tagId: val });
        this.disabledKeys = this.keyDisabled;
        if (oldVal) this.metas = [];
      }
    },

    dialog(val) {
      if (val) {
        if (
          this.deveui !== null &&
          this.deveui !== undefined &&
          this.deveui !== ""
        ) {
          this.getKeysForTag({ tagId: this.deveui });
        } else {
          this.getTdKeys();
        }
      }
    },

    type() {
      if (this.typeHasMeta()) {
        this.meta.key = this.metaKeysFiltered[0].key;
        this.metaChanged();
      }
      this.disabledKeys = this.keyDisabled;
    },
  },

  components: {
    ModuleTypeSelector,
    ModulePreview,
    StylePickerModule,
    TextEditorModule,
  },
};
</script>

<style>
.preserve-spacing {
  white-space: pre-wrap;
}

.dialog-fullscreen {
  max-width: 100%;
  margin: 0;
  padding: 0;
  overflow-x: hidden;
}
</style>
